import React, { useState } from "react";
import { Formik } from "formik";

import { Spinner } from "react-bootstrap";
import {
  HemaHeadingWithSubText,
  HemaLabel,
  Button,
  HemaValue,
} from "../../utils";
import { LoginEmail, CrossIcon, Reset } from "../../HemeIconLibrary";
import { resetPassowrdAction } from "../../Actions/auth";
import LoginInput from "../../utils/FormElements/loginInput";
import { Link } from "react-router-dom";

const LoginForm = ({ setFirstAttemptToSelectDropdown }) => {
  const [success, setSuccess] = useState(false);

  return !success ? (
    <div className="max-w-full lg:max-w-[450px]">
      <HemaHeadingWithSubText
        heading="Reset Password"
        sub=""
        subTextColor="#595959"
      />

      <Formik
        initialValues={{ email: "" }}
        enableReinitialize
        validate={(values) => {
          const errors = {};
          if (!values.email) {
            errors.email = "Required";
          } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
          ) {
            errors.email = "Please enter correct email format";
          }

          return errors;
        }}
        onSubmit={async (values, { setSubmitting }) => {
          const result = await resetPassowrdAction(values);
          setSubmitting(false);
          if (result?.status === 200) {
            setSuccess(true);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isSubmitting,
          /* and other goodies */
        }) => (
          <>
            <form onSubmit={handleSubmit}>
              <div className="flex flex-col  mb-[24px] mt-[24px]">
                <HemaLabel
                  text="Email"
                  Icon={<LoginEmail />}
                  textSize="text-[16px]"
                />
                <LoginInput
                  type="email"
                  name="email"
                  placeholder="Enter your Email"
                  crossIcon={values.email ? <CrossIcon /> : ""}
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  setFieldValue={setFieldValue}
                />
                <p className="error m-0  text-[#F54C3B]">
                  {errors.email && touched.email && errors.email}
                </p>
              </div>

              {isSubmitting ? (
                <Button
                  type="submit"
                  bg="bg-primary1"
                  className="w-full h-[48px] justify-center font-semibold"
                  text={
                    <>
                      <Spinner animation="grow" size="sm" variant="light" />
                      <Spinner animation="grow" size="sm" variant="light" />
                      <Spinner animation="grow" size="sm" variant="light" />
                    </>
                  }
                />
              ) : (
                <Button
                  text="Request Reset"
                  type="submit"
                  bg="bg-primary1"
                  border="border-primary1"
                  color="text-white"
                  className="w-full h-[48px] justify-center font-semibold"
                  disabled={values.email ? false : true}
                />
              )}
              <Link className="no-underline" to="/login">
                <Button
                  text="Back To Log In"
                  type="button"
                  bg="bg-primary1"
                  border="border-primary1"
                  color="text-white"
                  className="w-full h-[48px] justify-center font-semibold mt-[22px]"
                />
              </Link>
            </form>
          </>
        )}
      </Formik>
    </div>
  ) : (
    <div className="text-center max-w-[450px]">
      <HemaLabel Icon={<Reset />} className="justify-center pb-[16px]" />
      <HemaHeadingWithSubText heading="Reset Password" className="pb-[10px]" />
      <HemaValue
        text="Check your email for a link to reset your password. If it doesn’t appear within a few minutes, check your spam folder."
        className="pb-[36px]"
      />
      <Link to="/login" className="no-underline">
        <Button
          text="Go To Log In"
          type="submit"
          bg="bg-primary1"
          border="border-primary1"
          color="text-white"
          className="w-full h-[48px] justify-center font-semibold"
        />
      </Link>
    </div>
  );
};

export default LoginForm;
